<ev-dialog [visible]="show()" (close)="closeDialog()" (confirm)="confirmDialog()" [maxWidth]="'460px'" [title]="'Slett'">
    <p class="dialog-content-text">Du har ulagrede endringer i listen. Er du sikker på at du vil lukke listen?</p>
</ev-dialog>
